import { FlagsPermissionBulkBookingV2 } from "@/feature-flags/flags-bulk-booking-v2";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");
const BulkBookingV2Create = () =>
  import(
    /* webpackChunkName: "BulkBooking" */ "@/app/ui/views/shipment/bulk-booking-v2/create-bulk-booking/create.vue"
  );

export default [
  {
    path: "/shipment/bulk/bulk-v2",
    component: Layout,
    name: "shipment-create-bulk-v2",
    meta: {
      title: "Bulk Booking",
      hidden: true,
      parent: "Bulk Booking",
      permission: FlagsPermissionBulkBookingV2.feature_bulk_booking_v2
    },
    children: [
      {
        path: "create",
        name: "create-bulk-v2",
        component: BulkBookingV2Create,
        meta: {
          header: true,
          customPath: "create-bulk-v2",
          isAuth: false
        }
      }
    ]
  }
]